import React, { useEffect } from "react";
import { connect } from "react-redux";
import EmployeeTable from "./components/EmployeeTable";
import DownloadButton from "components/button/download";
import UploadButton from "components/button/upload";
import { getCountryList } from "../../../redux/optionlist/optionlistState";

const Employees = ({getCountryOptions, filters}) => {
	
	useEffect(() => {
	    getCountryOptions({});
    }, [getCountryOptions]);

	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">

	      	<EmployeeTable/>
	      	
	      	<div className="flex flex-row-reverse text-right">	      		
	      		<DownloadButton downloadPath="employee-details" title="Download" filters={filters}/>
	      		<UploadButton uploadPath="employee-details" title="Upload"/>
	      	</div>
	      	
	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
  filters: state.employee.employeeList?.filters,
});

const mapDispatchToProps = (dispatch) => ({
  getCountryOptions: (filters) => dispatch(getCountryList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Employees);